import { Box } from '@mui/material';
import { PropertyDetailsResponseData } from '../../../../models/details.models.tsx';

const mapboxKey = import.meta.env.VITE_MAPBOX_PUBLIC_KEY as string;

const mapboxImageZoom = 15.25;
const mapboxImageBearing = 0;
const mapboxImagePitch = 0;

interface ImageSectionProps {
  propertyData: PropertyDetailsResponseData | undefined;
  mlsImage?: string;
  showMlsImage?: boolean;
}

export const ImageSection = ({
  propertyData,
  showMlsImage = false,
  mlsImage = 'https://images.pexels.com/photos/4091975/pexels-photo-4091975.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
}: ImageSectionProps) => {
  const propertyLongitude = propertyData?.longitude;
  const propertyLatitude = propertyData?.latitude;

  const images = [
    `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/${propertyLongitude},${propertyLatitude},${mapboxImageZoom},${mapboxImageBearing},${mapboxImagePitch}/400x400?access_token=${mapboxKey}`,
    `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/${propertyLongitude},${propertyLatitude},${mapboxImageZoom},${mapboxImageBearing},${mapboxImagePitch}/400x400?access_token=${mapboxKey}`,
    mlsImage,
  ];

  return (
    <Box
      className="data-page-images-container"
      sx={{ display: 'flex', flexDirection: 'row' }}
    >
      {showMlsImage && (
        <div style={{ flex: 4, padding: '8px' }}>
          <img
            src={`${mlsImage}`}
            style={{ width: '100%', height: 'auto', aspectRatio: '6 / 5' }}
            alt=""
          />
        </div>
      )}

      {!showMlsImage &&
        images.map((image, index) => {
          return (
            <div key={index} style={{ flex: 4, padding: '8px' }}>
              <img
                src={`${image}`}
                style={{ width: '100%', height: 'auto', aspectRatio: '6 / 5' }}
                alt=""
              />
            </div>
          );
        })}
    </Box>
  );
};
